// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7169":"86647d20","7857":"55830e87"}[chunkId] + ".chunk.css";
};